import { ALIGN_MAPPING } from "../constanst";
import { getPaddingString, toRGBA } from "../parser/utils";

export default ({ data, id }) => {
  const { width, align, height, style, color, contentID } = data;
  return `
    <div id="${contentID || id}" style="${getPaddingString(data)}; display: flex;justify-content: ${ALIGN_MAPPING[align]};">
      <div style="width: ${width}%;border-bottom-width: ${height}px;border-bottom-style: ${style};border-bottom-color: ${color ? toRGBA(color) : "transparent"};"></div>
    </div>
  `;
};
